var map = {
	"./no-data_chart-g.svg": "d3b4",
	"./no-data_chart.svg": "a461",
	"./no-data_filter.svg": "4f6c",
	"./no-data_group.svg": "bfd2",
	"./no-data_item.svg": "b1f4",
	"./no-data_law.svg": "6ab4",
	"./no-data_list.svg": "21a7",
	"./no-data_location.svg": "4930b",
	"./no-data_lock.svg": "f424",
	"./no-data_person.svg": "ee9c",
	"./no-data_piechart.svg": "0d83",
	"./no-data_search.svg": "d3c54",
	"./no-data_setting.svg": "bdca",
	"./no-data_storage.svg": "6248"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5606";